<template>
    <div class="pb-4">
        <template v-if="!$store.state.settings?.disable_seasonal_designs">
            <link v-if="$store.getters.isSpring" rel="stylesheet" href="/css/spring/app.css">
            <link v-if="$store.getters.isSpookySeason" rel="stylesheet" href="/css/spookyseason/app.css">
            <link v-if="$store.getters.isWinter" rel="stylesheet" href="/css/winter/app.css">
        </template>

        <launch-bar/>

        <router-view class="mt-5 dipocaco-router-view"></router-view>
        <navigation-bar/>
<!--        <music-player :pre-selected-playlist="0"></music-player>-->

        <template v-if="!$store.state.settings?.disable_seasonal_designs">
            <snowflakes v-if="$store.getters.isWinter"/>
            <cherry-blossoms v-if="$store.getters.isSpring"/>
            <animated-background-video v-if="$store.getters.isSpookySeason"></animated-background-video>
        </template>
    </div>
</template>

<script>
import LaunchBar from "../parts/LaunchBar.vue";
import NavigationBar from "../parts/NavigationBar.vue";
// import InfoFooter from "../parts/InfoFooter.vue";
import Snowflakes from "../parts/Snowflakes.vue";
import AnimatedBackgroundVideo from "../parts/AnimatedBackgroundVideo.vue";
import CherryBlossoms from "../parts/CherryBlossoms.vue";

export default {
    name: "DipocacoApp",
    components: {CherryBlossoms, Snowflakes, LaunchBar, NavigationBar, AnimatedBackgroundVideo},
    data() {
        return {};
    },
    created() {
    },
    mounted() {
        moment.locale(this.$i18n.locale);
    },
};
</script>


<style scoped lang="scss">

</style>
